module.exports = __webpack_public_path__ + "static/media/lt.cb1bea16.svg";